const LanguageThemeOptions = {
  EN: "EN",
  FR: "FR",
};

export default LanguageThemeOptions;
